import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LogoMark } from "./Logo";
import { EASE } from "./Motion";

export const Preloader = ({ onReveal, onDone }) => {
  const [n, setN] = useState(0);
  const [exit, setExit] = useState(false);

  useEffect(() => {
    let raf;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min((t - start) / 1700, 1);
      setN(Math.round((1 - Math.pow(1 - p, 3)) * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
      else setTimeout(() => { setExit(true); onReveal(); }, 250);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onReveal]);

  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex flex-col justify-between bg-[#0A0A0A] p-6 md:p-10"
      initial={{ clipPath: "inset(0 0 0% 0)" }}
      animate={exit ? { clipPath: "inset(0 0 100% 0)" } : {}}
      transition={{ duration: 1.1, ease: EASE }}
      onAnimationComplete={() => exit && onDone()}
    >
      <div className="flex items-center justify-between text-neutral-100">
        <LogoMark className="h-7 w-auto" />
        <span className="eyebrow">Tri-Cities, TN</span>
      </div>
      <motion.img
        src="/brand/newland-logo-light.png"
        alt="Newland Construction"
        initial={{ clipPath: "inset(0 100% 0 0)", opacity: 0.4 }}
        animate={{ clipPath: "inset(0 0% 0 0)", opacity: 1 }}
        transition={{ duration: 1.4, ease: EASE, delay: 0.1 }}
        className="absolute left-1/2 top-1/2 w-[70vw] max-w-[520px] -translate-x-1/2 -translate-y-1/2"
      />
      <div className="flex items-end justify-between">
        <p className="max-w-xs font-mono text-xs uppercase tracking-[0.25em] text-neutral-500">
          Laying out the frame. Setting the posts. Squaring the corners.
        </p>
        <span className="font-display text-[22vw] font-extrabold leading-[0.8] tracking-tighter text-neutral-100 md:text-[14vw]">
          {String(n).padStart(3, "0")}
        </span>
      </div>
      <div className="absolute bottom-0 left-0 h-[2px] bg-white" style={{ width: `${n}%` }} />
    </motion.div>
  );
};
